import NewsListPage from './NewsListPage';

export const NewsListPageConfig = {
  routes: [
    {
      path: '/pages/news/news',
      exact: true,
      component: NewsListPage,
    },
    {
      path: '/pages/news/column',
      exact: true,
      component: NewsListPage,
    },
    {
      path: '/pages/news/tourInfo',
      exact: true,
      component: NewsListPage,
    },
  ],
};
